import * as React from "react";
const SvgExpand = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "currentColor",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M200-200v-240h80v160h160v80H200Zm480-320v-160H520v-80h240v240h-80Z" }));
export default SvgExpand;
